export default [
	{
		name: "user-basic",
		path: "/basic",
		component: () => import("@/views/user/Basic"),
		meta: { layout: "User", menu: "", title: "Basic Info" }
    },
	{
		name: "user-edit",
		path: "/edit",
		component: () => import("@/views/user/Edit"),
		meta: { layout: "User", menu: "", title: "Edit personal info" }
	},
	{
		name: "user-delete",
		path: "/delete",
		component: () => import("@/views/user/Delete"),
		meta: { layout: "User", menu: "", title: "Delete Account" }
	},
	{
		name: "user-reset-password",
		path: "/resetPwd",
		component: () => import("@/views/user/ResetPwd"),
		meta: { layout: "User", menu: "", title: "Reset Password" }
	},
	{
		name: "user-edit-account",
		path: "/editAccount",
		component: () => import("@/views/user/EditAccount"),
		meta: { layout: "User", menu: "", title: "Account" }
	},
];
